import { render } from "./LanguajeComponent.vue?vue&type=template&id=0a41c6c0"
import script from "./LanguajeComponent.vue?vue&type=script&lang=js"
export * from "./LanguajeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__